module.exports = __webpack_public_path__ + "img/loading.3754b31e.gif";